export const TOOLTIP_COLUMN_TOPIC_NAME = "topic";

export const TOOLTIP_COLUMN_SCORE_NAME = "compositeScore";

export const TOOLTIP_COLUMN_SCORE_DELTA_NAME = "compositeScoreDelta";

export const TOOLTIP_COLUMN_DOMAINS_NAME = "domainsCount";
